/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tx_Status_FailedInputs */

const en_tx_status_failed = /** @type {(inputs: Tx_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const id_tx_status_failed = /** @type {(inputs: Tx_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Tx_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tx_status_failed = /** @type {((inputs?: Tx_Status_FailedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tx_Status_FailedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tx_status_failed(inputs)
	return en_tx_status_failed(inputs)
});